import React, { FC, useState } from 'react'
import { Modal } from 'Components/Modal/Modal'
import { BenefitProgramForm } from 'Pages/JOONAdmin/EmployerDetailsPage/Views/BenefitPrograms/CreateBenefitProgramModal/BenefitProgramForm'
import { BenefitProgramPolicyForm } from 'Pages/JOONAdmin/EmployerDetailsPage/Views/BenefitPrograms/CreateBenefitProgramModal/BenefitProgramPolicyForm'
import { EmployerBenefitProgram } from 'Utils/types/benefitProgram'
import { FlexRow, spacingSM } from 'Utils/styles/spacing'
import { ViewSelector } from 'Pages/JOONAdmin/EmployerDetailsPage/EmployerDetailsContent'
import { MerchantForm } from 'Pages/JOONAdmin/EmployerDetailsPage/Views/BenefitPrograms/CreateBenefitProgramModal/MerchantForm'
import { ProgramRecurringAllowances } from 'Pages/JOONAdmin/EmployerDetailsPage/Views/BenefitPrograms/CreateBenefitProgramModal/ProgramRecurringAllowances'

enum BenefitProgramViews {
  Program = 'Program',
  Merchants = 'Merchants',
  Policy = 'Policy',
  RecurringAllowances = 'Recurring Allowances'
}

type CreateBenefitProgramModalProps = {
  showModal: boolean
  setShowModal: (a: boolean) => void
  selectedProgram?: EmployerBenefitProgram
}

export const CreateBenefitProgramModal: FC<CreateBenefitProgramModalProps> = ({
  showModal,
  setShowModal,
  selectedProgram
}) => {
  const [selectedView, setSelectedView] = useState(BenefitProgramViews.Program)
  const [prevShowModal, setPrevShowModal] = useState(showModal)

  if (showModal !== prevShowModal) {
    setPrevShowModal(showModal)
    if (showModal) {
      setSelectedView(BenefitProgramViews.Program)
    }
  }

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      maxWidth={1200}
      minWidth={1000}
      overflow
    >
      <FlexRow gap={spacingSM}>
        {Object.entries(BenefitProgramViews).map(([key, value]) => (
          <ViewSelector
            key={key}
            id={`edit.benefit.program.view.selection.${key}.label`}
            secondary
            disabled={selectedProgram === undefined}
            $selected={selectedView === value}
            onClick={() => setSelectedView(value)}
          />
        ))}
      </FlexRow>
      {selectedView === BenefitProgramViews.Program && (
        <BenefitProgramForm
          selectedProgram={selectedProgram}
          closeModal={() => setShowModal(false)}
        />
      )}
      {selectedView === BenefitProgramViews.Merchants && selectedProgram && (
        <MerchantForm program={selectedProgram} />
      )}
      {selectedView === BenefitProgramViews.Policy && selectedProgram && (
        <BenefitProgramPolicyForm
          selectedProgram={selectedProgram}
          closeModal={() => setShowModal(false)}
        />
      )}
      {selectedView === BenefitProgramViews.RecurringAllowances && selectedProgram && (
        <ProgramRecurringAllowances program={selectedProgram} />
      )}
    </Modal>
  )
}
